/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsLocaleModule
 */
export interface ControlcenterMelcoModelsLocaleModule {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleModule
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleModule
     */
    name?: string | null;
}

export function ControlcenterMelcoModelsLocaleModuleFromJSON(json: any): ControlcenterMelcoModelsLocaleModule {
    return ControlcenterMelcoModelsLocaleModuleFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsLocaleModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsLocaleModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ControlcenterMelcoModelsLocaleModuleToJSON(value?: ControlcenterMelcoModelsLocaleModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


